<template>
  <div class="vacancies-item content">
    <div class="d-flex justify-content-between">
      <div>
        <p>
          <span class="font-weight-bold">Employment term: </span>
          <span>{{ vacancy && vacancy.employment_team }}</span>
        </p>
        <p>
          <span class="font-weight-bold">Category: </span>
          <span>{{ vacancy && vacancy.category }}</span>
        </p>
      </div>
      <div
        class="text-right m-b-50"
      >
        <p>
          <span class="font-weight-bold">Job Type: </span>
          <span>{{ vacancy && vacancy.job_type }}</span>
        </p>
        <p>
          <span class="font-weight-bold">Location: </span>
          <span>{{ vacancy && vacancy.location }}</span>
        </p>
      </div>
    </div>
    <div v-if="showContextDetails">
      <VacancyDetailsItems
        v-for="(item, i) in detailsContext"
        :key="i"
        :item="item"
      />
      <div class="d-flex justify-content-end">
        <b-btn
          class="btn-main-bg-blue btn-main-bg-blue-bordered"
          @click="redirectToApplyPage"
        >
          Apply
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import VacancyDetailsItems from '@/views/Careers/VacancyDetailsItems';
import { scrollToTop } from '@/helpers/helpers';
import { R_APPLY } from '@/router/routes';
import { VACANCY } from '@/constants/applyFormTypes';

export default {
  name: 'VacancyDetailsTest',
  components: { VacancyDetailsItems },
  props: {
    vacancy: {
      type: Object,
      default: () => {},
    },
    showContextDetails: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    detailsContext() {
      return this.showContextDetails ? this.contextMapper : null;
    },
    contextMapper() {
      if (this.vacancy) {
        const keys = ['job_description', 'job_responsibilities', 'required_qualifications'];
        let res = {};
        Object.keys(this.vacancy).forEach((el) => {
          if (keys.includes(el)) {
            res = {
              ...res,
              [el]: {
                title: el.split('_').join(' '),
                context: this.vacancy[el].split('\r\n'),
              },
            };
          }
        });
        return res;
      }
      return null;
    },
  },
  methods: {
    redirectToApplyPage() {
      scrollToTop();
      this.$router.push({
        name: R_APPLY,
        query: {
          type: VACANCY,
          id: this.vacancy.id,
        },
      });
    },
  },
};
</script>
